// Pure normalization utilities for the Item 11 import flows.
// Used by dedupe + preview + hook. No side effects, no DB calls.

export function normalizePhone(raw: string | null | undefined): string {
  if (!raw) return '';
  const digits = String(raw).replace(/\D+/g, '');
  return digits;
}

export function normalizeEmail(raw: string | null | undefined): string {
  if (!raw) return '';
  const trimmed = String(raw).trim().toLowerCase();
  return trimmed;
}

export function normalizeName(raw: string | null | undefined): string {
  if (!raw) return '';
  return String(raw).trim().replace(/\s+/g, ' ');
}
